export type User = any

export interface UsersState {
    loading: boolean
    resultuser: string | null
    users: User[]
    user: User | null
    useractivate: string | null
    clerk: User[]
    usersForSelect: User[]
    commercials: User[]
    total: number
}

const initialState: UsersState = {
    loading: false,
    resultuser: null,
    users: [],
    user: null,
    useractivate: null,
    clerk: [],
    usersForSelect: [],
    commercials: [],
    total: 0,
}

export const usersReducer = (state: UsersState = initialState, action: { type: string; payload?: any }): UsersState => {
    switch (action.type) {
        case "USER_GETALL_SUCCESS":
            return {
                ...state,
                loading: false,
                users: action.payload.users as User[],
                clerk: (action.payload.users as User[]).filter((user: any) => user.rol === "clerk"),
                commercials: (action.payload.users as User[]).filter((user: any) => user.rol === "commercial"),
                total: action.payload.total,
                resultuser: null,
                useractivate: state.useractivate,
            }

        case "USER_GETALLFORSELECT_SUCCESS":
            return {
                ...state,
                usersForSelect: action.payload as User[],
                clerk: (action.payload as User[]).filter((user: any) => user.rol === "clerk"),
                commercials: (action.payload as User[]).filter((user: any) => user.rol === "commercial"),
                loading: false,
                resultuser: null,
                useractivate: state.useractivate,
            }

        case "USER_GET_SUCCESS":
            return {
                ...state,
                loading: false,
                user: action.payload.user as User,
            }

        case "USER_RESET":
            return {
                ...state,
                user: null,
            }

        case "USER_ADD_SUCCESS":
            return {
                ...state,
                loading: false,
                resultuser: action.payload.message,
                useractivate: action.payload.idUser as string,
                user: action.payload.user as User,
                users: [...state.users, action.payload.user as User],
            }

        case "USER_WRONG_SUCCESS":
            return {
                ...state,
                loading: false,
                resultuser: action.payload.message,
            }

        case "USER_EDIT_SUCCESS":
            if (action.payload.user && action.payload.user._id) {
                const updatedUser = action.payload.user
                return {
                    ...state,
                    loading: false,
                    resultuser: action.payload.message,
                    user: updatedUser as User,
                    users: state.users.map((u: any) =>
                        u._id === updatedUser._id ? { ...updatedUser, sucursal: updatedUser.sucursal ?? u.sucursal } : u
                    ),
                    clerk: state.clerk.map((u: any) =>
                        u._id === updatedUser._id ? { ...updatedUser, sucursal: updatedUser.sucursal ?? u.sucursal } : u
                    ),
                    commercials: state.commercials.map((u: any) =>
                        u._id === updatedUser._id ? { ...updatedUser, sucursal: updatedUser.sucursal ?? u.sucursal } : u
                    ),
                    useractivate: state.useractivate
                }
            } else {
                return {
                    ...state,
                    loading: false,
                    resultuser: action.payload as string,
                }
            }

        case "USER_NOTHINGHERE":
            return {
                ...state,
                loading: false,
                resultuser: "nothinghere",
            }

        case "USER_RESET_RESULT":
            return {
                ...state,
                resultuser: null,
            }

        case "USER_LOADING":
            return {
                ...state,
                loading: true,
            }

        case "USER_NOT_LOADING":
            return {
                ...state,
                loading: false,
            }

        default:
        return state
    }
}
